import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getFacturacion = (query) => http.get(`${api}/operacion/compra-proveedores`, { params: { ...query } })

export {
  getFacturacion
}
